import React from 'react';
import Layout from '../components/layout/layout';
import SubPageLayout from '../components/subPageLayout/subPageLayout';
import YourAccount from '../components/subPageLayout/yourAccount/yourAccount';

const YourAccountPage = () => (
  <Layout>
    <SubPageLayout showGraphic={true} fullHeight={true}>
      <YourAccount />
    </SubPageLayout>
  </Layout>
);

export default YourAccountPage;
